import React, { useEffect } from 'react';
import { IZone } from '../../../models';
import { Alert, Box, TextField } from '@mui/material';
import { PhoneNumberMask } from '../../../components';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSubscribeZoneMutation } from '../../../store/apis';
import ErrorIcon from '@mui/icons-material/Error';

interface ZoneSubscribeFormProps {
  zone: IZone;
  next: () => void;
}
export const ZoneSubscribeForm = React.forwardRef((props: ZoneSubscribeFormProps, ref) => {
  const { zone, next } = props;
  const [mutate, { isLoading, isSuccess, isError, error }] = useSubscribeZoneMutation();

  React.useImperativeHandle(ref, () => ({ onSubmit: () => formManager.handleSubmit(), isSuccess }), []);

  const formManager = useFormik({
    enableReinitialize: true,

    initialValues: {
      phone: '',
    },

    validationSchema: Yup.object({
      phone: Yup.string().required('Phone is required.'),
    }),

    onSubmit: (values) => {
      const { phone } = values;

      mutate({ zoneId: zone.id, phone });
    },
  });

  useEffect(() => {
    if (!isLoading && isSuccess && !isError) {
      // submit was successful
      next();
    }
  }, [isLoading, isSuccess, isError]);

  const getErrorMessage = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return error?.data?.payload?.message ?? 'There was an error submitting this form.';
  };

  return (
    <Box>
      {isError && (
        <Alert icon={<ErrorIcon />} color="error">
          {getErrorMessage()}
        </Alert>
      )}
      <TextField
        placeholder="Phone number"
        variant="filled"
        type="text"
        fullWidth
        margin="dense"
        value={formManager.values.phone}
        name="phone"
        InputProps={{
          inputComponent: PhoneNumberMask as any,
        }}
        onChange={formManager.handleChange('phone')}
        error={!!(formManager.errors.phone && formManager.touched.phone)}
        helperText={formManager.touched.phone ? formManager.errors.phone : null}
      />
    </Box>
  );
});
